import { getData } from 'src/services/RestApi';
import { getCachedData } from 'src/utils/data-cache';
import { formatDate } from 'src/utils/date-locale';
import { distanceColor, expiredColor } from 'src/utils/color-rules';
const TypeChecker = require('src/utils/type-checker');

const getSummary = async () => {
  const { result } = await getData('api/teacher/summary');
  if (TypeChecker.isObject(result)){
    const month = `Tháng ${result.month}`;
    const kilometers = parseInt(result.distance, 10).toLocaleString('en-US');
    const quantity = parseInt(result.quantity, 10).toLocaleString('vi-VN');
    const hours =  result.hours;
    const working = result.working;

    return { month, hours, working, kilometers, quantity };
  }
  return {};
};

const getStatistic = async () => {
  const { result } = await getData('api/teacher/statistic');
  if (TypeChecker.isArray(result)){
    result.forEach(element => {
      element.distance = parseInt(element.distance, 10).toLocaleString('en-US');
      element.quantity = parseInt(element.quantity, 10).toLocaleString('vi-VN');
    });

    return result;
  }
  return [];
};

const getAssigned = async () => {
  const { result } = await getData('api/car/my/assigned');
  if (TypeChecker.isArray(result)) {
    const keysMapping = getCachedData('keysMapping');
    const carTransmission = keysMapping?.carTransmission || {};

    result.forEach(element => {
      element.transmission = carTransmission[element.transmission];
       
      if(TypeChecker.isArray(element.services)){
        element.services.forEach(item => {
          if(item.expiredOn){
            const { remider, color } = expiredColor(item.expiredOn, element.today);
            item.color = color;
            item.value = formatDate(item.expiredOn, 'dd/MM/yyyy');
          }else{
            const { maintenance, color } = distanceColor(item.currentKm, item.limitAt, element.lastKm)
            item.color = color;
            item.value = parseInt(maintenance, 10).toLocaleString('en-US');
          }
        });
      }
    });
    return result;
  }
  return [];
};


export { getSummary, getStatistic, getAssigned };
